import api, { register as apiRegister, login as apiLogin } from '../../utils/api';

class UserService {
    // 1. הוספנו את 'language' כפרמטר
    static async register(name, email, password, language = 'he') {
        try {
            const { data } = await apiRegister({
                fullName: name,
                email,
                password,
                language // 2. שולחים את השפה לשרת
            });
            if (data.token && data.user) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('currentUser', JSON.stringify(data.user));
                return data.user;
            } else {
                // 3. זורקים שגיאה גנרית באנגלית. הקומפוננטה תתרגם אותה.
                throw new Error('Invalid response from server during registration');
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.msg) {
                throw new Error(error.response.data.msg);
            }
            throw error;
        }
    }

    static async login(email, password) {
        try {
            const { data } = await apiLogin({
                email,
                password
            });
            if (data.token && data.user) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('currentUser', JSON.stringify(data.user));
                return data.user;
            } else {
                throw new Error('Invalid server response');
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.msg) {
                throw new Error(error.response.data.msg);
            }
            throw error;
        }
    }

    static getCurrentUser() {
        try {
            const userStr = localStorage.getItem('currentUser');
            return userStr ? JSON.parse(userStr) : null;
        } catch (error) {
            localStorage.removeItem('currentUser');
            return null;
        }
    }

    static async logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        return Promise.resolve();
    }
}
export default UserService;